import React from 'react'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { EMARResidentStockScreen } from './EMARResidentStockScreen'
import EMARResidentStockScreenV2 from '../ResidentEmarV2Screens/EMARResidentStockScreenV2/EMARResidentStockScreenV2'

const EMARResidentStockScreenWrapper: React.FC = () => {
  const flags = useFeatureFlags({ flagNames: ['emar_v2_stock'] })?.data

  const newEmarEnabled = flags?.emar_v2_stock?.enabled ?? false

  if (newEmarEnabled) {
    return <EMARResidentStockScreenV2 />
  }

  return <EMARResidentStockScreen />
}

export default EMARResidentStockScreenWrapper
